// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__Qz7DP","spinner-c7wet2":"Spinner_spinner-c7wet2__l0Fl3"};